module.exports = {
	"contractName": "Ownable",
	"abi": [
		{
			"constant": true,
			"inputs": [],
			"name": "owner",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "constructor"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "previousOwner",
					"type": "address"
				},
				{
					"indexed": true,
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "OwnershipTransferred",
			"type": "event"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "transferOwnership",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		}
	],
	"bytecode": "0x608060405234801561001057600080fd5b5060008054600160a060020a03191633179055610173806100326000396000f30060806040526004361061004b5763ffffffff7c01000000000000000000000000000000000000000000000000000000006000350416638da5cb5b8114610050578063f2fde38b14610081575b600080fd5b34801561005c57600080fd5b506100656100a4565b60408051600160a060020a039092168252519081900360200190f35b34801561008d57600080fd5b506100a2600160a060020a03600435166100b3565b005b600054600160a060020a031681565b600054600160a060020a031633146100ca57600080fd5b600160a060020a03811615156100df57600080fd5b60008054604051600160a060020a03808516939216917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e091a36000805473ffffffffffffffffffffffffffffffffffffffff1916600160a060020a03929092169190911790555600a165627a7a72305820f93c3b589a31c04ad38286bf8e2ab285573e30836aa3ba59eee7a669a913b8e10029",
	"deployedBytecode": "0x60806040526004361061004b5763ffffffff7c01000000000000000000000000000000000000000000000000000000006000350416638da5cb5b8114610050578063f2fde38b14610081575b600080fd5b34801561005c57600080fd5b506100656100a4565b60408051600160a060020a039092168252519081900360200190f35b34801561008d57600080fd5b506100a2600160a060020a03600435166100b3565b005b600054600160a060020a031681565b600054600160a060020a031633146100ca57600080fd5b600160a060020a03811615156100df57600080fd5b60008054604051600160a060020a03808516939216917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e091a36000805473ffffffffffffffffffffffffffffffffffffffff1916600160a060020a03929092169190911790555600a165627a7a72305820f93c3b589a31c04ad38286bf8e2ab285573e30836aa3ba59eee7a669a913b8e10029",
	"sourceMap": "217:787:29:-;;;469:55;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;501:5:29;:18;;-1:-1:-1;;;;;;501:18:29;509:10;501:18;;;217:787;;;;;;",
	"deployedSourceMap": "217:787:29:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;238:20;;8:9:-1;5:2;;;30:1;27;20:12;5:2;238:20:29;;;;;;;;-1:-1:-1;;;;;238:20:29;;;;;;;;;;;;;;832:169;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;832:169:29;-1:-1:-1;;;;;832:169:29;;;;;;;238:20;;;-1:-1:-1;;;;;238:20:29;;:::o;832:169::-;653:5;;-1:-1:-1;;;;;653:5:29;639:10;:19;631:28;;;;;;-1:-1:-1;;;;;908:22:29;;;;900:31;;;;;;958:5;;;937:37;;-1:-1:-1;;;;;937:37:29;;;;958:5;;;937:37;;;980:5;:16;;-1:-1:-1;;980:16:29;-1:-1:-1;;;;;980:16:29;;;;;;;;;;832:169::o",
	"source": "pragma solidity ^0.4.18;\n\n\n/**\n * @title Ownable\n * @dev The Ownable contract has an owner address, and provides basic authorization control\n * functions, this simplifies the implementation of \"user permissions\".\n */\ncontract Ownable {\n  address public owner;\n\n\n  event OwnershipTransferred(address indexed previousOwner, address indexed newOwner);\n\n\n  /**\n   * @dev The Ownable constructor sets the original `owner` of the contract to the sender\n   * account.\n   */\n  function Ownable() public {\n    owner = msg.sender;\n  }\n\n  /**\n   * @dev Throws if called by any account other than the owner.\n   */\n  modifier onlyOwner() {\n    require(msg.sender == owner);\n    _;\n  }\n\n  /**\n   * @dev Allows the current owner to transfer control of the contract to a newOwner.\n   * @param newOwner The address to transfer ownership to.\n   */\n  function transferOwnership(address newOwner) public onlyOwner {\n    require(newOwner != address(0));\n    OwnershipTransferred(owner, newOwner);\n    owner = newOwner;\n  }\n\n}\n",
	"sourcePath": "zeppelin-solidity/contracts/ownership/Ownable.sol",
	"ast": {
		"absolutePath": "zeppelin-solidity/contracts/ownership/Ownable.sol",
		"exportedSymbols": {
			"Ownable": [
				2922
			]
		},
		"id": 2923,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 2868,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".18"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:29"
			},
			{
				"baseContracts": [],
				"contractDependencies": [],
				"contractKind": "contract",
				"documentation": "@title Ownable\n@dev The Ownable contract has an owner address, and provides basic authorization control\nfunctions, this simplifies the implementation of \"user permissions\".",
				"fullyImplemented": true,
				"id": 2922,
				"linearizedBaseContracts": [
					2922
				],
				"name": "Ownable",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"constant": false,
						"id": 2870,
						"name": "owner",
						"nodeType": "VariableDeclaration",
						"scope": 2922,
						"src": "238:20:29",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_address",
							"typeString": "address"
						},
						"typeName": {
							"id": 2869,
							"name": "address",
							"nodeType": "ElementaryTypeName",
							"src": "238:7:29",
							"typeDescriptions": {
								"typeIdentifier": "t_address",
								"typeString": "address"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"anonymous": false,
						"documentation": null,
						"id": 2876,
						"name": "OwnershipTransferred",
						"nodeType": "EventDefinition",
						"parameters": {
							"id": 2875,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2872,
									"indexed": true,
									"name": "previousOwner",
									"nodeType": "VariableDeclaration",
									"scope": 2876,
									"src": "291:29:29",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2871,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "291:7:29",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 2874,
									"indexed": true,
									"name": "newOwner",
									"nodeType": "VariableDeclaration",
									"scope": 2876,
									"src": "322:24:29",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2873,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "322:7:29",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "290:57:29"
						},
						"src": "264:84:29"
					},
					{
						"body": {
							"id": 2884,
							"nodeType": "Block",
							"src": "495:29:29",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 2882,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 2879,
											"name": "owner",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2870,
											"src": "501:5:29",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 2880,
												"name": "msg",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2937,
												"src": "509:3:29",
												"typeDescriptions": {
													"typeIdentifier": "t_magic_message",
													"typeString": "msg"
												}
											},
											"id": 2881,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "sender",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "509:10:29",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"src": "501:18:29",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 2883,
									"nodeType": "ExpressionStatement",
									"src": "501:18:29"
								}
							]
						},
						"documentation": "@dev The Ownable constructor sets the original `owner` of the contract to the sender\naccount.",
						"id": 2885,
						"implemented": true,
						"isConstructor": true,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "Ownable",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2877,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "485:2:29"
						},
						"payable": false,
						"returnParameters": {
							"id": 2878,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "495:0:29"
						},
						"scope": 2922,
						"src": "469:55:29",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 2895,
							"nodeType": "Block",
							"src": "625:46:29",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 2891,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2888,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2937,
														"src": "639:3:29",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 2889,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "sender",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "639:10:29",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"id": 2890,
													"name": "owner",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2870,
													"src": "653:5:29",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "639:19:29",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 2887,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "631:7:29",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 2892,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "631:28:29",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 2893,
									"nodeType": "ExpressionStatement",
									"src": "631:28:29"
								},
								{
									"id": 2894,
									"nodeType": "PlaceholderStatement",
									"src": "665:1:29"
								}
							]
						},
						"documentation": "@dev Throws if called by any account other than the owner.",
						"id": 2896,
						"name": "onlyOwner",
						"nodeType": "ModifierDefinition",
						"parameters": {
							"id": 2886,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "622:2:29"
						},
						"src": "604:67:29",
						"visibility": "internal"
					},
					{
						"body": {
							"id": 2920,
							"nodeType": "Block",
							"src": "894:107:29",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 2908,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 2904,
													"name": "newOwner",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2898,
													"src": "908:8:29",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"hexValue": "30",
															"id": 2906,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "928:1:29",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															}
														],
														"id": 2905,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "920:7:29",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_address_$",
															"typeString": "type(address)"
														},
														"typeName": "address"
													},
													"id": 2907,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "920:10:29",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "908:22:29",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 2903,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "900:7:29",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 2909,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "900:31:29",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 2910,
									"nodeType": "ExpressionStatement",
									"src": "900:31:29"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 2912,
												"name": "owner",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2870,
												"src": "958:5:29",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"id": 2913,
												"name": "newOwner",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2898,
												"src": "965:8:29",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											],
											"id": 2911,
											"name": "OwnershipTransferred",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2876,
											"src": "937:20:29",
											"typeDescriptions": {
												"typeIdentifier": "t_function_event_nonpayable$_t_address_$_t_address_$returns$__$",
												"typeString": "function (address,address)"
											}
										},
										"id": 2914,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "937:37:29",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 2915,
									"nodeType": "ExpressionStatement",
									"src": "937:37:29"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2918,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 2916,
											"name": "owner",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2870,
											"src": "980:5:29",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2917,
											"name": "newOwner",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2898,
											"src": "988:8:29",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"src": "980:16:29",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 2919,
									"nodeType": "ExpressionStatement",
									"src": "980:16:29"
								}
							]
						},
						"documentation": "@dev Allows the current owner to transfer control of the contract to a newOwner.\n@param newOwner The address to transfer ownership to.",
						"id": 2921,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": null,
								"id": 2901,
								"modifierName": {
									"argumentTypes": null,
									"id": 2900,
									"name": "onlyOwner",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 2896,
									"src": "884:9:29",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$__$",
										"typeString": "modifier ()"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "884:9:29"
							}
						],
						"name": "transferOwnership",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2899,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2898,
									"name": "newOwner",
									"nodeType": "VariableDeclaration",
									"scope": 2921,
									"src": "859:16:29",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2897,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "859:7:29",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "858:18:29"
						},
						"payable": false,
						"returnParameters": {
							"id": 2902,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "894:0:29"
						},
						"scope": 2922,
						"src": "832:169:29",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					}
				],
				"scope": 2923,
				"src": "217:787:29"
			}
		],
		"src": "0:1005:29"
	},
	"legacyAST": {
		"absolutePath": "zeppelin-solidity/contracts/ownership/Ownable.sol",
		"exportedSymbols": {
			"Ownable": [
				2922
			]
		},
		"id": 2923,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 2868,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".18"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:29"
			},
			{
				"baseContracts": [],
				"contractDependencies": [],
				"contractKind": "contract",
				"documentation": "@title Ownable\n@dev The Ownable contract has an owner address, and provides basic authorization control\nfunctions, this simplifies the implementation of \"user permissions\".",
				"fullyImplemented": true,
				"id": 2922,
				"linearizedBaseContracts": [
					2922
				],
				"name": "Ownable",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"constant": false,
						"id": 2870,
						"name": "owner",
						"nodeType": "VariableDeclaration",
						"scope": 2922,
						"src": "238:20:29",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_address",
							"typeString": "address"
						},
						"typeName": {
							"id": 2869,
							"name": "address",
							"nodeType": "ElementaryTypeName",
							"src": "238:7:29",
							"typeDescriptions": {
								"typeIdentifier": "t_address",
								"typeString": "address"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"anonymous": false,
						"documentation": null,
						"id": 2876,
						"name": "OwnershipTransferred",
						"nodeType": "EventDefinition",
						"parameters": {
							"id": 2875,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2872,
									"indexed": true,
									"name": "previousOwner",
									"nodeType": "VariableDeclaration",
									"scope": 2876,
									"src": "291:29:29",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2871,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "291:7:29",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 2874,
									"indexed": true,
									"name": "newOwner",
									"nodeType": "VariableDeclaration",
									"scope": 2876,
									"src": "322:24:29",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2873,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "322:7:29",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "290:57:29"
						},
						"src": "264:84:29"
					},
					{
						"body": {
							"id": 2884,
							"nodeType": "Block",
							"src": "495:29:29",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 2882,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 2879,
											"name": "owner",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2870,
											"src": "501:5:29",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 2880,
												"name": "msg",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2937,
												"src": "509:3:29",
												"typeDescriptions": {
													"typeIdentifier": "t_magic_message",
													"typeString": "msg"
												}
											},
											"id": 2881,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "sender",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "509:10:29",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"src": "501:18:29",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 2883,
									"nodeType": "ExpressionStatement",
									"src": "501:18:29"
								}
							]
						},
						"documentation": "@dev The Ownable constructor sets the original `owner` of the contract to the sender\naccount.",
						"id": 2885,
						"implemented": true,
						"isConstructor": true,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "Ownable",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2877,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "485:2:29"
						},
						"payable": false,
						"returnParameters": {
							"id": 2878,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "495:0:29"
						},
						"scope": 2922,
						"src": "469:55:29",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 2895,
							"nodeType": "Block",
							"src": "625:46:29",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 2891,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2888,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2937,
														"src": "639:3:29",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 2889,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "sender",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "639:10:29",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"id": 2890,
													"name": "owner",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2870,
													"src": "653:5:29",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "639:19:29",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 2887,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "631:7:29",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 2892,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "631:28:29",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 2893,
									"nodeType": "ExpressionStatement",
									"src": "631:28:29"
								},
								{
									"id": 2894,
									"nodeType": "PlaceholderStatement",
									"src": "665:1:29"
								}
							]
						},
						"documentation": "@dev Throws if called by any account other than the owner.",
						"id": 2896,
						"name": "onlyOwner",
						"nodeType": "ModifierDefinition",
						"parameters": {
							"id": 2886,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "622:2:29"
						},
						"src": "604:67:29",
						"visibility": "internal"
					},
					{
						"body": {
							"id": 2920,
							"nodeType": "Block",
							"src": "894:107:29",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 2908,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 2904,
													"name": "newOwner",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2898,
													"src": "908:8:29",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"hexValue": "30",
															"id": 2906,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "928:1:29",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															}
														],
														"id": 2905,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "920:7:29",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_address_$",
															"typeString": "type(address)"
														},
														"typeName": "address"
													},
													"id": 2907,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "920:10:29",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "908:22:29",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 2903,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "900:7:29",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 2909,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "900:31:29",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 2910,
									"nodeType": "ExpressionStatement",
									"src": "900:31:29"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 2912,
												"name": "owner",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2870,
												"src": "958:5:29",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"id": 2913,
												"name": "newOwner",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2898,
												"src": "965:8:29",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											],
											"id": 2911,
											"name": "OwnershipTransferred",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2876,
											"src": "937:20:29",
											"typeDescriptions": {
												"typeIdentifier": "t_function_event_nonpayable$_t_address_$_t_address_$returns$__$",
												"typeString": "function (address,address)"
											}
										},
										"id": 2914,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "937:37:29",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 2915,
									"nodeType": "ExpressionStatement",
									"src": "937:37:29"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2918,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 2916,
											"name": "owner",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2870,
											"src": "980:5:29",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2917,
											"name": "newOwner",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2898,
											"src": "988:8:29",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"src": "980:16:29",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 2919,
									"nodeType": "ExpressionStatement",
									"src": "980:16:29"
								}
							]
						},
						"documentation": "@dev Allows the current owner to transfer control of the contract to a newOwner.\n@param newOwner The address to transfer ownership to.",
						"id": 2921,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": null,
								"id": 2901,
								"modifierName": {
									"argumentTypes": null,
									"id": 2900,
									"name": "onlyOwner",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 2896,
									"src": "884:9:29",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$__$",
										"typeString": "modifier ()"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "884:9:29"
							}
						],
						"name": "transferOwnership",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2899,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2898,
									"name": "newOwner",
									"nodeType": "VariableDeclaration",
									"scope": 2921,
									"src": "859:16:29",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2897,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "859:7:29",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "858:18:29"
						},
						"payable": false,
						"returnParameters": {
							"id": 2902,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "894:0:29"
						},
						"scope": 2922,
						"src": "832:169:29",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					}
				],
				"scope": 2923,
				"src": "217:787:29"
			}
		],
		"src": "0:1005:29"
	},
	"compiler": {
		"name": "solc",
		"version": "0.4.24+commit.e67f0147.Emscripten.clang"
	},
	"networks": {},
	"schemaVersion": "2.0.1",
	"updatedAt": "2020-10-22T15:28:26.817Z"
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/Ownable.json
// module id = 1048
// module chunks = 0